export const useCaseCard = [
  {
    title: "Amazon Connect Launch + GenAI Chatbot",
    description:
      "Scene to Believe Delivers Magical Experiences with AI-Powered Omnichannel Contact Centre",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/stb-thumbnail-iris.png",
  },
  {
    title: "Amazon Connect with AI, Automation & Analytics",
    description:
      "Unified, intelligent customer experience across leading payment brands - empowered by iCXeed on AWS.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/global-payments-thumbnail-iris.png",
  },
  {
    title: "Amazon Connect Managed Service & Intelligent AI Analytics",
    description:
      "From Australia's #1 accident management provider to a data-driven, AI-optimised customer experience - powered by iCXeed.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/aamc-thumbnail-iris.png",
  },
  {
    title: "Amazon Connect Managed Service",
    description:
      "Modernising education support with omnichannel communications, AI automation, and deep analytics.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/kip-mcgrath-thumbnail-iris.png",
  },
  {
    title: "Amazon Connect Launch + iCXeed Managed Service",
    description:
      "Empowering speed, intelligence, and continuous CX innovation with a secure, modern cloud contact centre.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/fingermark-thumbnail-iris.png",
  },
  {
    title:
      "Salesforce-Amazon Connect Integration and Intelligent Bot Deployment",
    description:
      "Sentral and iCXeed unified customer support with Salesforce, Amazon Connect, and Bedrock-powered self-service, delivering smarter digital support and greater efficiency.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/sentral-thumbnail-iris.png",
  },
  {
    title: "Accelerating College Admissions with AI",
    description:
      "Benilde partnered with iCXeed to launch a multilingual, AI-powered admissions concierge that provides 24/7 guidance, reduces staff workload, and establishes a scalable AI foundation for the student lifecycle.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/benilde-thumbnail-iris.png",
  },
  {
    title:
      "Pioneering Omnichannel Cloud Contact Center with Amazon Connect for Shipping and Logistics",
    description:
      "Chelsea Logistics partnered with iCXeed to launch Amazon Connect in the Philippines, delivering an AI-powered omnichannel support solution with 24/7 self-service and real-time tracking.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/chelsea-thumbnail-iris.png",
  },
];
